
import { UserContent } from "../../components/auth"

export default function User () {

  return (
    <>
      <UserContent/>
    </>
  )

}